import React from 'react'
import '../../styles/ResourceSection/ResourceHeader.scss'

const ResourceHeader = () => {
  return (
        <div className="resource_header">
            <h3 className="resource_header_title">How to prepare for your phone call with the SmartAsset team:</h3>
            <p className="resource_header_description">
                The SmartAsset concierge team will be reaching out shortly to discuss your advisor matches and connect you in real-time. In the meantime,
                check out these resources to prepare for your <span className="green">FREE</span> introductory call.
            </p>
        </div>
  )
}

export default ResourceHeader
